// Lightweight A/B-Test-Hook: weist Besucher persistent einer Variante zu
// (50/50-Split). URL-Override via ?ab=A oder ?ab=B möglich (für QA / Testing).
//
// Variante A = Editorial (ruhig, Magazin-Stil)
// Variante B = Direct-Response (Urgency, Schmerzpunkt zuerst)
//
// Der Variant-Code wird zusätzlich in die Lead-Source-String gehängt:
//   `ads-lp-wer-darf-was:NW:A` oder `…:B`
// So kann das Bundesland-Stats-Dashboard pro Variante auswerten.

const STORAGE_KEY = "dh-ab-wdw";

export function getAbVariant() {
  if (typeof window === "undefined") return "A";

  // URL-Override (für manuelles QA-Testing)
  const params = new URLSearchParams(window.location.search);
  const forced = (params.get("ab") || "").toUpperCase();
  if (forced === "A" || forced === "B") {
    try { localStorage.setItem(STORAGE_KEY, forced); } catch {}
    return forced;
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "A" || stored === "B") return stored;
    const variant = Math.random() < 0.5 ? "A" : "B";
    localStorage.setItem(STORAGE_KEY, variant);
    return variant;
  } catch {
    return "A";
  }
}
